import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import store from '../views/store/index'
// 公共组件 侧边栏 顶部 底部
import main from '@/views/components/HelloWorld'
import H5Pay_main from '@/views/H5Pay/main'
//pc 登录页
import login from '@/views/login.vue'
import NotFound from '@/views/publicComponents/notFound.vue'

import globalPath from '@/assets/script/globalPath'
import common from '@/assets/script/common.js'

Vue.use(Router);
const router = new Router({
    mode: "history",
    routes: [
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/',
            name: 'main',
            component: main,
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: "/",
                    redirect: '/home'
                }
            ]
        },
        {
            path: '/H5',
            name: 'H5Pay_main',
            component: H5Pay_main,
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: "/H5",
                    redirect: '/H5/H5Login'
                },
                {
                    path: '/H5/H5Login',
                    name: 'login',
                    component: () => import ('@/views/H5Pay/login.vue')
                },
                //充值记录和申请开票
                {
                    path: '/H5/Rechargerecord',
                    name: 'Rechargerecord',
                    component: () => import ('@/views/H5Pay/Rechargerecord.vue')
                },
                {
                    path: '/H5/comproblem',
                    name: 'comproblem',
                    component: () => import ('@/views/H5Pay/comproblem.vue')
                },
                {
                    path: '/H5/home',
                    name: 'home',
                    component: () => import ('@/views/H5Pay/home.vue')
                },
                // 激活卡片
                {
                    path: '/H5/activationCard',
                    name: 'activationCard',
                    component: () => import ('@/views/H5Pay/activationCard.vue')
                },
                // 订购套餐
                {
                    path: '/H5/PackageRenewal',
                    name: 'PackageRenewal',
                    component: () => import ('@/views/H5Pay/PackageRenewal.vue')
                },
                // 订购加油包
                {
                    path: '/H5/OrderFuelPacks',
                    name: 'OrderFuelPacks',
                    component: () => import ('@/views/H5Pay/OrderFuelPacks.vue')
                },
                {
                    path: '/H5/EditCardNumber',
                    name: 'EditCardNumber',
                    component: () => import ('@/views/H5Pay/EditCardNumber.vue')
                },
                
            ]
        }
    ]
});
let router_lise = [];
// 未登录路由拦截
router.beforeEach((to, from, next) => {
    let isLogin = common.getCookie('tibiot-personal-card'); // 获取token
    //路由设置
    if(to.path.includes('/H5')){
        //卡片激活后跳转首页后，不可以后退
        if(from.path == '/H5/H5Login' && to.path  == '/H5/Recharge') { //禁止激活后后退到激活页
            next({path:'/H5/H5Login'})
        }else if(from.path == '/H5/home' && to.path  == '/H5/Recharge'){ //禁止激活后后退到激活页
            next({path:'/H5/H5Login'})
        }else{
            next()
        }
    }else{
        if (isLogin) {
            getMbx(to); //获取面包屑
            getMenuId(to.meta.index) //获取当前页面的按钮权限
            if (router_lise == 0) { //路由开始
                getRouters(to,from, next);
            } else {
                next()
            }
        }else {
            if (to.path == '/login') {
                router_lise = [];
                next()
            }else {
                router_lise = [];
                next({path: "/login"})
            }
        }
    }
    
});
// 当在渲染一个路由的过程中，需要尝试解析一个异步组件时发生错误
router.onError((error) => {
    console.log('error:'+ error.message); 
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) {
      window.location.reload();
    }else{
      console.log(error)
    }
});
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

//获取页面按钮
function getMenuId(index){
    if(index){
        axios({
            method: 'post',
            url: globalPath.globalPath.api + 'admin/role/getSysRoleMenu',
            data: {menuId:index},
        })
        .then(function (res) {
            if (res.data.code == 200 ) {
                if(Array.isArray(res.data.data)){
                    store.commit('setButtons', res.data.data);//存储页面的按钮
                }else{
                    store.commit('setButtons', []);//存储页面的按钮
                }
            }
        }).catch(() => console.log('获取页面按钮Error'));
    }
}
//设置面包屑
function getMbx(to){
    if (getCrumbs(to).flog) {
        let cc = store.state.jumpMenu;
        if (store.state.jumpMenu.index == 2){
            getCrumbs(to).bb[2] = cc;
        } else {
            getCrumbs(to).bb[1] = cc;
        } 
        store.commit('setCrumbsArr', getCrumbs(to).bb);
    } else {
        store.commit('setCrumbsArr', getCrumbs(to).mianbaoxian);
    }
}
//获取面包屑
function getCrumbs(to){
    let bb = store.state.crumbsArr; //储存面包屑
    let arrmenu = store.state.menu;
    let mianbaoxian = [];
    let flog = true;
    for (let i = 0; i < arrmenu.length; i++) {
        if (arrmenu[i].menuUrl == to.path) {
            mianbaoxian[0] = {
                name: arrmenu[i].menuName,
                url: arrmenu[i].menuUrl,
            };
            mianbaoxian.length = 1;
            flog = false;
            break;
        } else {
            if (arrmenu[i].children) {
                for (let j = 0; j < arrmenu[i].children.length; j++) {
                    if (arrmenu[i].children[j].menuUrl == to.path) {
                        mianbaoxian[0] = {
                            name: arrmenu[i].menuName,
                            url: arrmenu[i].children[j].menuUrl,
                        };
                        mianbaoxian[1] = {
                            name: arrmenu[i].children[j].menuName,
                            url: arrmenu[i].children[j].menuUrl
                        };
                        mianbaoxian.length = 2;
                        flog = false;
                        break;
                    }
                }
            }
        }
    }
    return {bb,mianbaoxian,flog}
}

//获取路由
function getRouters(to,from, next) {
    router_lise = [];
    axios({
        method: 'post',
        url: globalPath.globalPath.api + 'home/getSysMenuRoute',
    })
    .then(function (res) {
        if (res.data.code == 200 && Array.isArray(res.data.data) && res.data.data.length) {
            router_lise = addDynamicRoutes(res.data.data);
            router.options.routes[1].children = router_lise;
            router.options.routes[3] = {path: '/404', name: '404', component: NotFound};
            router.options.routes[4] = {path: '*', redirect: '/404'};
            router.matcher = new Router().matcher;
            router.addRoutes(router.options.routes);
            if(from.path == '/login' || from.path == '/'){
                next({path: "/home"});
            }else{
                next({...to});
            }
        }else{
            if (to.path === '/login') {
                next()
            } else {
                next({path: "/login"})
            }
        }
        
    }).catch(function (err) {
        if (to.path === '/login') {
          next()
        } else {
          next({path: "/login"})
        }
      })
}
function addDynamicRoutes(menuList = [], routes = []) {
    for (let i = 0; i < menuList.length; i++) {
        if (menuList[i].menuUrl) {
            let url = menuList[i].menuUrl;
            let route = {
                path: url,
                name: url.substr(1),
                component: () => import(`@/views/page${url}`),
                meta: {
                    index: menuList[i].id,
                    name: menuList[i].menuName
                }
            };
            routes.push(route);
        }
    }
    return routes
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js